import React, { useState } from 'react';
import { AddAttribute, UpdateAttribute } from '../Services/AttributeService';

const AddAttributeModal = ({ onClose, attribute }) => {
  const isEdit = !!attribute;

  const [formData, setFormData] = useState({
    name: attribute?.name || '',
    description: attribute?.description || '',
    controlType: attribute?.controlType || 'Dropdown',
    required: attribute?.required || false,
    displayOrder: attribute?.displayOrder || 0,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Attribute Submitted:', formData);
    
    // Parse order integer
    const payload = {
      ...formData,
      displayOrder: parseInt(formData.displayOrder) || 0,
    };

    let res;
    if (isEdit) {
      res = await UpdateAttribute(attribute.id, payload);
    } else {
      res = await AddAttribute(payload);
    }

    if (res?.status) {
      onClose();
    } else {
      alert(`Failed to ${isEdit ? 'update' : 'add'} attribute. ${res?.message || 'Please try again.'}`);
    }
  };

  return (
    <div className="add-category-modal">
      <form className="add-category-form" style={{ maxWidth: '500px' }} onSubmit={handleSubmit}>
        <div className="header">
          <h2 className="title">{isEdit ? 'Update Attribute' : "Add Attribute"}</h2>
          <button
            type="button"
            className="close-btn"
            onClick={onClose}
          >
            &times;
          </button>
        </div>

        <div className="form-content" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <div className="form-group">
            <label htmlFor="name">Attribute Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="e.g. Grinding Texture"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">Description</label>
            <input
              type="text"
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="e.g. Texture settings for grinding"
            />
          </div>

          <div className="form-group">
            <label htmlFor="controlType">Control Type</label>
            <select
              id="controlType"
              name="controlType"
              value={formData.controlType}
              onChange={handleChange}
              className="form-control"
              style={{ padding: '10px', borderRadius: '8px', border: '1px solid #ccc' }}
            >
              <option value="Dropdown">Dropdown</option>
              <option value="RadioList">Radio List</option>
              <option value="Checkboxes">Checkboxes</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="displayOrder">Display Order</label>
            <input
              type="number"
              id="displayOrder"
              name="displayOrder"
              value={formData.displayOrder}
              onChange={handleChange}
              placeholder="0"
            />
          </div>

          <div className="form-group d-flex align-items-center gap-2 mt-3 mb-3">
            <input
              type="checkbox"
              id="required"
              name="required"
              checked={formData.required}
              onChange={handleChange}
              style={{ width: '20px', height: '20px', cursor: 'pointer' }}
            />
            <label htmlFor="required" style={{ margin: 0, cursor: 'pointer', fontWeight: 'bold' }}>Is Required?</label>
          </div>
        </div>

        <div className="footer">
          <button type="submit" className="submit-btn">
            {isEdit ? 'UPDATE ATTRIBUTE' : 'ADD ATTRIBUTE'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddAttributeModal;
